import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { SignalBars } from "../components/common";
import DarkNetSequence from "../components/DarkNetSequence";

const BG = "https://images.unsplash.com/photo-1544259342-306eccfec481?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [connecting, setConnecting] = useState(null);

  async function submit(e) {
    e?.preventDefault();
    setError("");
    setBusy(true);
    try {
      const u = await login(email.trim(), password);
      setConnecting(u);
    } catch (err) {
      setError(errMsg(err));
      setBusy(false);
    }
  }

  return (
    <div className="h-full w-full flex items-center justify-center p-4 relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{ backgroundImage: `url(${BG})`, backgroundSize: "cover", backgroundPosition: "center", opacity: 0.22 }}
      />
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 30%, rgba(45,212,191,0.08), rgba(7,9,13,0.96) 70%)" }} />

      {connecting && (
        <DarkNetSequence
          identifier={email.trim()}
          role={connecting.role}
          onComplete={() => nav(connecting.role === "gm" ? "/gm" : "/play", { replace: true })}
        />
      )}

      <div className="relative z-10 w-full" style={{ maxWidth: 400 }}>
        <div className="frame glow-primary p-7 fade-up" style={{ background: "rgba(13,17,23,0.92)", backdropFilter: "blur(8px)" }}>
          <div className="flex items-center justify-between mb-1">
            <SignalBars />
            <span className="sys-label">NODE · 7781-A</span>
          </div>
          <h1 className="font-title font-black text-3xl tracking-tight text-glow glitch-hover mt-4" style={{ color: "var(--r-text)" }}>
            RÉPLA <span style={{ color: "var(--r-primary)" }}>// COM</span>
          </h1>
          <p className="sys-label mt-2">CONNEXION AU NODE · IDENTIFICATION REQUISE</p>

          <form onSubmit={submit} className="mt-6 space-y-3">
            <div>
              <span className="sys-label block mb-1.5">IDENTIFIANT REPLA</span>
              <input
                data-testid="login-email-input"
                className="input font-mono"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ABC-1234"
                autoComplete="username"
                autoCapitalize="characters"
                spellCheck={false}
              />
            </div>
            <div>
              <span className="sys-label block mb-1.5">MOT DE PASSE</span>
              <input
                data-testid="login-password-input"
                type="password"
                className="input font-mono"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="font-mono text-xs py-2 px-3" style={{ color: "var(--r-alert)", border: "1px solid var(--r-alert)", background: "rgba(239,68,68,0.08)" }}>
                ✕ {error}
              </div>
            )}

            <button data-testid="login-submit-button" type="submit" disabled={busy} className="btn btn-solid w-full mt-2">
              {busy ? "CONNEXION…" : "ACCÉDER AU RÉPLA"}
            </button>
          </form>
        </div>
        <div className="text-center mt-4 sys-label">RÉSEAU TACHYONIQUE · TRANSMISSION CHIFFRÉE</div>
      </div>
    </div>
  );
}
